import { createFileRoute } from '@tanstack/react-router'
import { Organization } from '@/pages/Organization'

export const Route = createFileRoute('/_authenticated/organizations/$id/')({
  component: Organization,
})
